<template>
  <div>
    <generic-container
      :title="title"
      icon="shopping cart"
      :header_buttons="header_buttons"
    >
      <div class="ui divided cart selection list">
        <div
          class="item"
          v-for="(item, index) in cart"
          :key="index"
          @click="edit_item(item, index)"
        >
          <i class="map marker icon"></i>
          <div class="content">
            <div
              class="ui mini red right floated icon button"
              :data-tooltip="$t('delete')"
              @click.stop="delete_item(item, index)"
            >
              <i class="trash icon"></i>
            </div>
            <a class="ui right floated large basic green tag label">{{
              item.subtotal | formatCurrency(enterprise_setup.currency_iso)
            }}</a>
            <a
              @click.stop="select_alternate_price(index, vr.value)"
              style="margin-right: 10px"
              v-bind:class="{ hidden: !vr.value }"
              class="ui right floated basic label"
              v-for="(vr, idx) in item.product.setup.variations"
              :key="idx"
              >{{ vr.name }}
              {{ vr.value | formatCurrency(enterprise_setup.currency_iso) }}</a
            >
            <a
              style="margin-right: 10px"
              class="ui right floated small basic red label"
              v-if="item.discount_percentage"
            >
              -{{ item.discount_percentage }}% ({{
                ((item.quantity * item.discount_percentage * item.sale_price) /
                  100)
                  | formatCurrency
              }})
            </a>
            <a class="header">{{ item.quantity }} x {{ item.product.name }}</a>
            <div class="description">
              {{
                item.sale_price | formatCurrency(enterprise_setup.currency_iso)
              }}
              {{ $t("per unit") }}.
            </div>
          </div>
        </div>
      </div>
      <a class="ui orange right ribbon label">
        <div class="ui small horizontal right floated statistic">
          <div class="value">
            {{ total | formatCurrency(enterprise_setup.currency_iso) }}
          </div>
          <div class="label">{{ $t("total") }}</div>
        </div>
      </a>
      <template v-for="(mdl, index) in item_modals">
        <component
          :is="mdl"
          :key="index"
          :item="selected_item"
          v-on:finished="edit_succedded"
          @destroy="destroy_modals"
        ></component>
      </template>
      <template v-for="(mdl, index) in payment_modals">
        <component
          :is="mdl"
          :key="index"
          :total="total"
          :customer="customer"
          :cart="cart"
          :session="current_session"
          @payment_success="payment_succedded"
          @destroy="destroy_modals"
        ></component>
      </template>
      <!-- <pre>{{ cart }}</pre> -->
    </generic-container>
  </div>
</template>

<script>
import { local_api, error_toast, enterprise_setup } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import ItemModal from "./ItemModal";
// import PaymentModal from "./payment/PaymentModal";
import { cloneDeep } from "lodash";

// @ is an alias to /src
export default {
  name: "PointOfSaleCart",
  components: {
    "generic-container": GenericContainer,
  },
  filters: filters,
  data() {
    return {
      uuid: undefined,
      name: "",
      cart: [],
      selected_item: undefined,
      item_modals: [],
      payment_modals: [],
      customer: undefined,
      header_buttons: [
        {
          icon: "red eraser",
          tooltip: this.$t("clear"),
          click: this.clear,
        },
      ],
      current_session: undefined,
    };
  },
  computed: {
    total() {
      let _sum = this.cart.reduce(function(prev, current) {
        return prev + current.subtotal;
      }, 0);
      return _sum;
    },
    title() {
      if (this.name) return `${this.$t("cart")} [${this.name}]`;
      else return this.$t("cart");
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    add_to_cart(product) {
      let trgt = this.cart.find((n) => n.product.uuid == product.uuid);
      if (trgt) {
        trgt.quantity++;
        trgt.subtotal = this.item_subtotal(trgt); //  trgt.quantity * trgt.sale_price;
      } else {
        this.cart.push({
          quantity: 1,
          product: {
            uuid: product.uuid,
            name: product.name,
            id: product.product_id,
            setup: JSON.parse(product.setup),
          },
          sale_price: product.sale_price,
          taxes: Number(product.setup.taxes_percentage),
          discount_percentage: 0,
          subtotal: Number(product.sale_price),
        });
      }
    },
    item_subtotal(item) {
      let _consume = item.quantity * item.sale_price;
      let _discount =
        (item.quantity * (item.discount_percentage * item.sale_price)) / 100;
      return _consume - _discount;
    },
    clear() {
      this.cart = [];
      this.selected_item = undefined;
      this.name = "";
      this.uuid = undefined;
    },
    edit_item(item) {
      this.selected_item = item;
      this.item_modals.push(ItemModal);
    },
    delete_item(item, index) {
      this.cart.splice(index, 1);
    },
    edit_succedded(item) {
      let trgt = this.cart.find((n) => n.product.uuid == item.product.uuid);
      if (trgt) {
        trgt.quantity = item.quantity;
        trgt.sale_price = item.sale_price;
        trgt.discount_percentage = item.discount_percentage;
        trgt.subtotal = this.item_subtotal(trgt);
      }
    },
    save() {
      let vm = this;
      if (!vm.uuid) {
        this.$alertify.prompt(this.$t("enter order name"), vm.name, function(
          element,
          value,
        ) {
          vm.do_save(value);
        });
      } else vm.do_save(vm.name);
    },
    do_save(name) {
      let vm = this;
      local_api(vm, "post", "/point_of_sale/account/do-save", {
        u: vm.uuid,
        n: name,
        s: { products: vm.cart, total: vm.total },
      })
        .then((response) => {
          vm.$emit("order_saved", response);
          vm.clear();
          // vm.$alertify(vm.$t("order saved"));
        })
        .catch((err) => {
          error_toast(err);
        })
        .finally(() => {
          // vm.processing = false;
        });
    },
    load_account(account) {
      let _acc = cloneDeep(account);
      let vm = this;
      vm.uuid = _acc.uuid;
      vm.name = _acc.name;
      vm.cart = _acc.setup.products;
    },
    // payment() {
    //   // if (this.cart.length > 0) this.payment_modals.push(PaymentModal);
    // },
    // payment_succedded() {
    //   this.clear();
    //   this.$emit("payment_succedded");
    // },
    select_customer(customer) {
      this.customer = customer;
    },
    set_session(session) {
      this.current_session = session;
    },
    destroy_modals() {
      this.item_modals = [];
      this.payment_modals = [];
    },
    select_alternate_price(index, price) {
      let trgt = this.cart[index];
      if (trgt) {
        trgt.sale_price = price;
        trgt.subtotal = this.item_subtotal(trgt);
      }
    },
    get_product_list() {
      return this.cart;
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style>
.ui.cart.divided.list .item:last-child {
  border-bottom: 1px dashed;
}
</style>
